import {merge, get, map} from 'lodash';
import moment from 'moment';
import {inlineSchema} from './utils';
import i18n from '../i18n';
import * as Subprofile from './subprofile';
import * as Profile from './profile';
import * as Group from './group';
import * as MyAppointment from './appointment-as';
import * as MyOrder from './order-as';
import * as EmergencyContact from './emergency_contact';
import * as ServiceLocation from './service_location';
import debug from 'src/debug';
import {formatPhone} from 'src/utils';

export default function (member) {
  let GE = 'fields.cat.general';
  let CL = 'fields.cat.client';
  let CG = 'fields.cat.caregiver';

  return {
    member_id: {type: 'id', required: true, cat: [GE, CL, CG]},
    created_at: {type: 'datetime', readonly: true, cat: [GE, CL, CG], list: 4},
    status: {
      type: 'select',
      items: ['status.active', 'status.inactive'],
      cat: [GE, CL, CG],
      list: 5,
    },
    tags: {type: 'tags', unique: true}, //  for group assign, e.g. add all UC hall member to a private event
    role: {
      type: 'select',
      items: map(Object.keys(i18n.s('fields.roles')), x => 'fields.roles.' + x),
      readonly: true,
    },

    'details.profile': {
      cat: [GE, CL, CG],
      type: 'schema', expand: true, schema: inlineSchema({
        first_name: {type: 'string'},
        last_name: {type: 'string'},
        other_name: {type: 'string'},
        gender: {type: 'select', items: ['gender.m', 'gender.f']},
        birthday: {type: 'date'},
        profile_pic: {type: 'img'},
        // service_location: {
        //   type: 'array', add: true, delete: true,
        //   itemType: {type: 'schema', schema: ServiceLocation},
        // },
        // emergency_contact: {
        //   type: 'array', add: true, delete: true,
        //   itemType: {type: 'schema', schema: EmergencyContact},
        // },
        not_available_days: {
          readonly: true,
          type: 'array', itemType: {
            type: 'schema', schema: merge(inlineSchema({
              startTime: {type: 'date'},
              endTime: {type: 'date'},
            }), {
              title(model) {
                let start = moment(model.startTime).startOf('day');
                let end = moment(model.endTime).startOf('day');
                if (start.isSame(end)) {
                  return start.format('YYYY/MM/DD');
                } else {
                  return start.format('YYYY/MM/DD') + ' - ' + end.format('YYYY/MM/DD');
                }
              },
            }),
          },
        },
      }),
    },
    details: {
      cat: [CG],
      type: 'schema', schema: inlineSchema({
        notes: {type: 'text'},
        address: {type: 'string', hidden: !debug.DEBUG},
        hkid: {type: 'string', hidden: !debug.DEBUG},
        marriage_status: {type: 'string', hidden: !debug.DEBUG},
        bank_account: {type: 'string', hidden: !debug.DEBUG},
        bank_type: {type: 'string', hidden: !debug.DEBUG},
        referral: {type: 'string', hidden: !debug.DEBUG},
        signed_contract: {type: 'checkbox', hidden: !debug.DEBUG},
        working_visa: {type: 'checkbox', hidden: !debug.DEBUG},
        years_of_experience: {type: 'number', min: 0},
        working_experience: {type: 'text'},
        working_history: {
          type: 'array', add: true, delete: true, hidden: !debug.DEBUG,
          itemType: {
            type: 'schema', schema: merge(inlineSchema({
              title: {type: 'string'},
              company: {type: 'string'},
              startDate: {type: 'date'},
              endDate: {type: 'date'},
              fulltime: {type: 'checkbox'},
            }), {
              title(model) {
                return model ? model.title : '';
              },
            }),
          },
        },
        certificates: {
          type: 'array', add: true, delete: true, hidden: !debug.DEBUG,
          itemType: {
            type: 'schema', schema: merge(inlineSchema({
              name: {type: 'string'},
              issuer: {type: 'string'},
              startDate: {type: 'date'},
              endDate: {type: 'date'},
            }), {
              title(model) {
                return model ? model.name : '';
              },
            }),
          },
        },
      }),
    },

    //  system : basic
    'verification.email.value': {
      cat: [GE, CL, CG],
      type: 'string',
      label: 'fields.email',
      list: 1,
    },
    'verification.phone.value': {
      cat: [GE, CL, CG],
      type: 'phone',
      label: 'fields.phone',
      list: 2,
    },
    'details.profile.gender': {type: 'select', items: ['gender.m', 'gender.f'], hidden: true, list: 3},

    // email: {type: 'email', default: 'missing'}, // if init login with fb, can refuse to provide but set email_fulfilled to true
    basicInfo_fulfilled: {type: Boolean, default: false, list: false},
    email_fulfilled: {type: Boolean, default: false, list: false},

    groups: {
      cat: [CG],
      type: 'array', itemType: {
        type: 'schema', schema: merge(inlineSchema(function (model) {
          return {
            group: {type: 'schema', schema: Group, external: true, readonly: true},
            self_status: {
              readonly: true,
              type: 'select',
              items: [
                'status.pending',
                'status.approved',
                'status.rejected',
              ],
            }, // follow status.permission
            updated_at: {type: 'datetime', readonly: true},
            created_at: {type: 'datetime', readonly: true},
            refs: {
              type: 'schema', readonly: true, schema: inlineSchema({
                photo: {type: 'img', multi: true, readonly: true},
                reason: {type: 'string'},
              }),
            },
            action: {
              type: 'button',
              actions: [{
                label: 'action.approve',
                class: 'btn-success',
                hidden: model && ['pending', 'rejected'].indexOf(model.self_status) < 0,
                action(model, spec, readonly) {
                  let gid = get(model, 'group.group_id');
                  let mid = member.member_id;
                  return this.$http
                    .post('', {
                      endpoint: 'replyGroupApplications',
                      member_id: mid,
                      group_ids: [gid],
                      approval_status: 'approved',
                    })
                    .then(response => {
                      if (!response.body) {
                        throw new Error(i18n.f('alert.empty_response'));
                      }
                      let result = response.body;
                      if (!result.success) {
                        console.error(response);
                        return Promise.reject(result.err.hk || result.err);
                      }
                      if (this.$notify) {
                        this.$notify({
                          component: {
                            template: i18n.f('alert.html.record_updated_successfully'),
                          },
                          icon: 'ti-info',
                          horizontalAlign: 'center',
                          verticalAlign: 'top',
                          type: 'success',
                        });
                      }
                      return true; // reload
                    });
                },
              }, {
                label: 'action.reject',
                action(model, spec, readonly) {
                  let gid = get(model, 'group.group_id');
                  let mid = member.member_id;
                  return this.$http
                    .post('', {
                      endpoint: 'replyGroupApplications',
                      member_id: mid,
                      group_ids: [gid],
                      approval_status: 'rejected',
                    })
                    .then(response => {
                      if (!response.body) {
                        throw new Error(i18n.f('alert.empty_response'));
                      }
                      let result = response.body;
                      if (!result.success) {
                        console.error(response);
                        return Promise.reject(result.err.hk || result.err);
                      }
                      if (this.$notify) {
                        this.$notify({
                          component: {
                            template: i18n.f('alert.html.record_updated_successfully'),
                          },
                          icon: 'ti-info',
                          horizontalAlign: 'center',
                          verticalAlign: 'top',
                          type: 'success',
                        });
                      }
                      return true; // reload
                    });
                },
              }, {
                label: 'action.delete',
                class: 'btn-danger',
                action(model, spec, readonly) {
                  let gid = get(model, 'group.group_id');
                  let mid = member.member_id;
                  return this.$http
                    .post('', {
                      endpoint: 'replyGroupApplications',
                      member_id: mid,
                      group_ids: [gid],
                      approval_status: 'delete',
                    })
                    .then(response => {
                      if (!response.body) {
                        throw new Error(i18n.f('alert.empty_response'));
                      }
                      let result = response.body;
                      if (!result.success) {
                        console.error(response);
                        return Promise.reject(result.err.hk || result.err);
                      }
                      if (this.$notify) {
                        this.$notify({
                          component: {
                            template: i18n.f('alert.html.record_updated_successfully'),
                          },
                          icon: 'ti-info',
                          horizontalAlign: 'center',
                          verticalAlign: 'top',
                          type: 'success',
                        });
                      }
                      return true; // reload
                    });
                },
              }].filter(x => !x.hidden),
            },
          };
        }), {
          title(model) {
            return model ? i18n.nn`${Group.title.call(this, model.group)} (${i18n.fr('status.' + model.self_status)})` : '';
          },
        }),
      },
    },

    finished_interview: {
      cat: [CG],
      type: 'boolean',
    },


    //  system : role
    // role: {
    //   type: 'select',
    //   required: true,
    //   items: ['role.member', 'role.admin'],
    //   multi: false,
    //   list: false,
    //   hidden: true,
    // }, //  member / cashier ( ecommerce role )

    //
    init_login_type: {
      type: 'select', readonly: true,
      items: [/*'type.login.fb', 'type.login.wechat', */'type.login.emailPwd'],
      list: 3,
    },

    // auth: {
    //   salt: {type: String, default: null},
    //   pwdHash: {type: String, default: null},
    //   //  social login provider
    //   fb: {
    //     id: String,
    //     data: {},
    //   },
    //   wechat: {
    //     id: String,
    //     data: {},
    //   },
    // },


    // verification: {type: 'schema', schema: Verification},
    'verification.phone': {
      type: 'schema', schema: merge(inlineSchema({
        updated_at: {type: 'datetime', readonly: true}, //  prevent abuse
        status: {type: 'select', list: false, items: ['status.verified', 'status.not_verified']},
        value: {type: String},
        // code: {type: String},
      }), {
        title(model) {
          return formatPhone(get(model, 'value'));
        },
      }),
    },
    'verification.email': {
      type: 'schema', schema: merge(inlineSchema({
        updated_at: {type: 'datetime', readonly: true},
        status: {type: 'select', list: false, items: ['status.verified', 'status.not_verified']},
        value: {type: String},
        // code: {type: String},
      }), {
        title(model) {
          return get(model, 'value');
        },
      }),
    },

    //  login with activation code
    // activation_code: {type: String, list: false},

    app_config: {
      type: 'schema',
      schema: inlineSchema({
        'notification.sms': {type: 'boolean', default: true},
        'notification.email': {type: 'boolean', default: true},
        'notification.promotion': {type: 'boolean', default: true},
        language: {
          type: 'radio',
          items: Object.keys(i18n.lang).map(x => ({label: x.toUpperCase(), value: x})),
          default: i18n.local,
        },
        dev_mode: {type: 'checkbox', hidden: !debug.DEBUG},
        dev_stripe: {
          type: 'checkbox', hidden: !debug.DEBUG, readonly() {
            return !get(this.model, 'dev_mode');
          },
        },
      }),
    },

    // blacklist: [{
    //   created_at: {type: 'datetime', readonly: true},
    //   member: {type: String, ref: 'memberships', required: true},
    // }],

    stat: {
      type: 'schema',
      readonly: true,
      schema: inlineSchema({
        click: {type: 'number'},
        view: {type: 'number'},
        rating: {
          type: 'schema', schema: inlineSchema({
            admin_to_caregiver_avg: {type: 'number'},
            admin_to_caregiver_max: {type: 'number'},
            admin_to_caregiver_min: {type: 'number'},
            admin_to_client_avg: {type: 'number'},
            admin_to_client_max: {type: 'number'},
            admin_to_client_min: {type: 'number'},
            client_appointment_feedback_avg: {type: 'number'},
            client_appointment_feedback_max: {type: 'number'},
            client_appointment_feedback_min: {type: 'number'},
            caregiver_appointment_feedback_avg: {type: 'number'},
            caregiver_appointment_feedback_max: {type: 'number'},
            caregiver_appointment_feedback_min: {type: 'number'},
          }),
        },
      }),
    },

    apply_group: {
      cat: [CG],
      type: 'link', link: {
        label: i18n.fr('action.click_to_$action', {action: '${i18n.action.apply}'}),
        to(value, model, fieldSpec) {
          return model ? `/admin/groups/apply?member_id=${model.member_id}` : null;
        },
      },
    },

    certificates: {
      cat: [CG],
      type: 'file',
      multi: true,
      preprocess(payload) {
        payload.type = 'certificate';
        return payload;
      },
    },

    // payment_accounts: [{
    //   payment_account_id: {type: String, required: true},
    //   type: {type: String}, //  e.g. stripe
    //   card: {
    //     //  last4 : "4242"
    //     //  customer : "cus_AjaidjfdiJdf"
    //     //  country : "US"
    //     //  brand : "Visa"
    //   },
    //   updated_at: {type: 'datetime'},
    // }],

    // details: {
    //   cat: [CL, CG],
    //   type: 'schema', schema: inlineSchema({
    //     //  about the account owner
    //     profile: {type: 'schema', schema: Profile},
    //     //  if role == client, store the service-user e.g. the patient info )
    //     subprofiles: {
    //       type: 'array',
    //       itemType: {type: 'schema', schema: Subprofile, external: true},
    //     },
    //   }),
    // },
    //
    // subprofiles_count: {
    //   cat: [CL],
    //   type: 'number',
    //   hidden: true,
    //   readonly: true,
    //   sortable: false,
    //   get(model) {
    //     return get(model, 'details.subprofiles.length', 0);
    //   },
    // },

    add_subprofile: {
      cat: [CL],
      type: 'link', link: {
        label: i18n.fr('action.click_to_$action', {action: '${i18n.action.add}'}),
        to(value, model, fieldSpec) {
          return model ? `/admin/subprofiles/create?member_id=${model.member_id}` : null;
        },
      },
    },

    my_subprofiles: {
      cat: [CL],
      type: 'table', schema: Subprofile,
      initialFilter(value, model) {
        return {creator_id: model.member_id};
      },
    },
    my_appointments: {
      cat: [CL],
      type: 'table', schema: MyAppointment,
      initialFilter(value, model) {
        return {member_id: model.member_id, caregiver: model && model.groups.length};
      },
    },
    my_jobs: {
      cat: [CG],
      type: 'table', schema: MyAppointment,
      initialFilter(value, model) {
        return {member_id: model.member_id, caregiver: model && model.groups.length};
      },
    },
    my_orders: {
      cat: [CL],
      type: 'table', schema: MyOrder,
      initialFilter(value, model) {
        return {member_id: model.member_id};
      },
    },

    reset_password: {
      type: 'schema', schema: inlineSchema({
        new_password: {type: 'string', inputType: 'password'},
        confirm_password: {
          type: 'string', inputType: 'password', validator(v) {
            let a = get(member, 'reset_password.new_password');
            return (a == null || v === a) ? null : 'Password mismatch';
          },
        },
      }),
    },

    // for debug
    _tokens: {
      type: 'array', readonly: true,
      hidden: !debug.DEBUG,
      itemType: {type: 'json'},
    },

  };
}



// WEBPACK FOOTER //
// ./src/schemas/membership_db.js